var _defs, _circle, _circle2, _circle3, _circle4, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgNodes = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "nodes_svg__Ebene_1",
  "data-name": "Ebene 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 70.93 43.78"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nodes_svg__cls-1{fill:none;stroke:#3cc;stroke-miterlimit:10;stroke-width:5px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  className: "nodes_svg__cls-1",
  cx: 8.33,
  cy: 8.33,
  r: 5.83
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  className: "nodes_svg__cls-1",
  cx: 21.74,
  cy: 32.24,
  r: 9.04
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  className: "nodes_svg__cls-1",
  cx: 44.23,
  cy: 9.75,
  r: 5.41
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  className: "nodes_svg__cls-1",
  cx: 63.02,
  cy: 28.54,
  r: 5.41
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "nodes_svg__cls-1",
  d: "M11.28 13.67 17.06 25M27.98 25.69l12.54-12.02M57.62 29.52l-26.89 1.73"
})));

export default SvgNodes;